export default {
    SET_TEMPLATES (state, templates) {
      state.templates = templates
    },
    SET_SAVE_TEMPLATE_STATUS (state, saveTemplateStatus) {
      state.saveTemplateStatus = saveTemplateStatus
    },
    SET_MATCHING_TEMPLATES (state, matchingTemplates) {
      state.matchingTemplates = matchingTemplates
    },
    SET_LOAD_TEMPLATE_STATUS (state, loadTemplateStatus) {
      state.loadTemplateStatus = loadTemplateStatus
    },
    SET_EDIT_TEMPLATE_STATUS (state, editTemplateStatus) {
      state.editTemplateStatus = editTemplateStatus
    },
    SET_SAVE_QUERY_STATUS (state, saveQueryStatus) {
      state.saveQueryStatus = saveQueryStatus
    },
    SET_LOAD_QUERY_STATUS (state, loadQueryStatus) {
      state.loadQueryStatus = loadQueryStatus
    },
    SET_TEMPLATES_SEARCHQUERY (state, templates) {
      state.templatesSearchquery = templates
    },
    SET_EDIT_SEARCHQUERY_STATUS (state, editQuerySearchStatus) {
      state.editQuerySearchStatus = editQuerySearchStatus
    }
  }
